module.exports = __webpack_public_path__ + "img/logo.65bfd9e6.png";